module.exports = __webpack_public_path__ + "img/8248b83.png";